import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { NewsUser } from '../news-user.model';

@JsonObject('NewsUserResultsResponse')
export class NewsUserResultsResponse extends ApiResultsResponse<NewsUser> {

  @JsonProperty('results', [NewsUser])
  override results: NewsUser[] = [];

  @JsonProperty('results_total', Number)
  resultsTotal: number = 0;
}
